<template>
  <div id="app" class="bg-white" v-if="isInitialized">
    <div class="header container">
      <h1 class="title">Red Paper Heart</h1>
      <h2 class="subtitle">G Drive - Review Folder Project v.{{ $store.state.packageVersion }}</h2>
    </div>
    <div v-if="!isSignedIn" class="login container">
      <button id="authorize_button" v-if="!isSignedIn" @click="signIn" class="button">Authorize</button>
    </div>
    <div v-else>
      <div id="nav" class="container">
        <router-link to="/">Home</router-link> |
        <router-link to="/search">Search</router-link> |
        <router-link to="/about">About</router-link>
        | signed in as {{googleUser.getBasicProfile().getEmail()}} |
        <a
          href="#"
          id="signout_button"
          @click.stop="signOut"
        >Sign Out</a>
      </div>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// @ is an alias to /src
import '@/styles/app.scss'
import { mapState } from 'vuex'

export default {
  name: 'App',
  CLIENT_ID: '1073962289898-i5gctp219ds7ubb3hfo224cgdmtjbj4c.apps.googleusercontent.com',
  API_KEY: 'AIzaSyCEkXhgcj71zZoEIAYKRU9WEBIV5UecX1Y',
  // Array of API discovery doc URLs for APIs used by the quickstart
  DISCOVERY_DOCS: [
    'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'
  ],
  // Authorization scopes required by the API; multiple scopes can be included, separated by spaces.
  SCOPES: 'https://www.googleapis.com/auth/drive.readonly', // https://www.googleapis.com/auth/drive.metadata.readonly
  created () {
    window.gapi.load('client:auth2', this.initClient)
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['gFilesMap', 'gFilesMetaMap']),
    isSignedIn: {
      get () {
        return this.$store.state.isSignedIn
      },
      set (val) {
        this.$store.commit('setSignedInStatus', val)
      }
    },
    isInitialized: {
      get () {
        return this.$store.state.isInitialized
      },
      set (val) {
        this.$store.commit('setInitializedStatus', val)
      }
    },
    googleUser: {
      get () {
        return this.$store.state.googleUser
      },
      set (user) {
        this.$store.commit('setGoogleUser', user)
      }
    }
  },
  watch: {
    gFilesMap: {
      // immediate: true,
      deep: true,
      handler (val) {
        // console.log('gFilesMap updated')
      }
    },
    gFilesMetaMap: {
      // immediate: true,
      deep: true,
      handler (val) {
        // console.log('gFilesMetaMap updated')
      }
    }
  },
  methods: {
    initClient () {
      // console.log('scopes:', this.$options.SCOPES)
      window.gapi.client
        .init({
          apiKey: this.$options.API_KEY,
          clientId: this.$options.CLIENT_ID,
          discoveryDocs: this.$options.DISCOVERY_DOCS,
          scope: this.$options.SCOPES
        })
        .then(
          () => {
            // console.log('gapi initialized')
            this.isInitialized = true
            // Listen for sign-in state changes.
            window.gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus)
            // Handle the initial sign-in state.
            this.isSignedIn = window.gapi.auth2.getAuthInstance().isSignedIn.get()
            // store the logged in user
            this.googleUser = window.gapi.auth2.getAuthInstance().currentUser.get()

            // load user based settings from localStorage
            const settings = JSON.parse(localStorage.getItem(`${this.googleUser.getId()}`))
            if (settings && settings.version === this.$store.getters.appVersion) {
              this.$store.commit('initUserSettings', settings)
            }
            // this.$store.commit('initGFilesMetaMap', JSON.parse(localStorage.getItem('gFilesMetaMap')))
            // this.$store.commit('initGFilesMap', JSON.parse(localStorage.getItem('gFilesMap')))
            // console.log(this.$store.state.favoriteList)
            // console.log('current user ID:', this.googleUser.getId())
            // console.log('current user basic profile:', this.googleUser.getBasicProfile())
            // BasicProfile.getId()
            // BasicProfile.getName()
            // BasicProfile.getGivenName()
            // BasicProfile.getFamilyName()
            // BasicProfile.getImageUrl()
            // BasicProfile.getEmail()
            // console.log('current user getGrantedScopes:', this.googleUser.getGrantedScopes())
          },
          error => {
            // console.log(error)
            this.apiResult = JSON.stringify(error, null, 2)
          }
        )
    },
    updateSignInStatus (isSignedIn) {
      this.isSignedIn = isSignedIn
    },
    signIn () {
      window.gapi.auth2.getAuthInstance().signIn()
    },
    signOut () {
      window.gapi.auth2.getAuthInstance().signOut()
      this.$store.commit('clearStore')
      // todo: delete all data in this.$store and clear out localstorage
    }
  }
}
</script>
